import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import actions from "actions";
import constants from "constants";
import DashboardView from "components/Admin/Statistics/Dashboard";

const {
  loadAdminAdminDashboardWebinarsSaga,
  loadAdminAdminDashboardUsersSaga,
  showDashboardModalSaga
} = actions;

const { MODAL_TYPE_DASHBOARD } = constants;

class Dashboard extends Component {
  static propTypes = {
    children: PropTypes.node,
    className: PropTypes.string,
    dispatch: PropTypes.func.isRequired
  };

  constructor(props) {
    super(props);
    this.state = {
      page: 1,
      query: {
        register_from: null,
        register_to: null,
        logged_from: null,
        logged_to: null,
        user_type: null,
        county: null,
        hospital: ""
      }
    };
  }

  componentWillMount() {
    this.props.loadWebinars(this.state.page);
    this.loadStatistics();
  }

  onChangePage = (page = 1) => {
    this.setState(
      {
        page
      },
      () => {
        this.props.loadWebinars(this.state.page);
      }
    );
  };

  changeQuery = query => {
    this.setState({ query }, () => {
      if (this.timer) {
        clearTimeout(this.timer);
      }
      this.timer = setTimeout(this.loadStatistics, 500);
    });
  };

  onChangeQuery = (field, value) => {
    const query = { ...this.state.query, ...{ [field]: value } };
    this.changeQuery(query);
  };

  onDateRangeChange = (field, start, end) => {
    const query = {
      ...this.state.query,
      ...{ [`${field}_from`]: start, [`${field}_to`]: end }
    };
    this.changeQuery(query);
  };

  loadStatistics = () => {
    this.props.loadStatistics(this.state.query);
  };

  showUsersModal = (webinar_id, type, count, additional = {}) => {
    if (count != 0)
      this.props.showUsersModal(
        {
          webinar_id: webinar_id,
          type: type
        },
        additional
      );
  };

  render() {
    const { webinars, count, statistics } = this.props;
    const {
      onDateRangeChange,
      onChangeQuery,
      state: { query }
    } = this;

    return (
      <DashboardView
        webinars={webinars}
        webinarsCount={count}
        statistics={statistics}
        filters={query}
        filterProps={{
          onDateRangeChange,
          onChangeQuery,
          query
        }}
        showUsersModal={this.props.user_role === 'admin' && this.showUsersModal}
        paginationProps={{
          onChangePage: this.onChangePage,
          page: this.state.page,
          total_pages: this.props.total_pages
        }}
      />
    );
  }
}

function mapStateToProps(state) {
  return {
    webinars: state.webinars.dashboardWebinars.values,
    count: state.webinars.dashboardWebinars.count,
    total_pages: state.webinars.dashboardWebinars.total_pages,
    statistics: state.users.statistics,
    user_role: state.users.user.role
  };
}

function mapDispatchToProps(dispatch) {
  return {
    loadWebinars: page => dispatch(loadAdminAdminDashboardWebinarsSaga(page)),
    loadStatistics: query => dispatch(loadAdminAdminDashboardUsersSaga(query)),
    showUsersModal: (contentProps, additional = {}) =>
      dispatch(
        showDashboardModalSaga(MODAL_TYPE_DASHBOARD, contentProps, additional)
      )
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Dashboard);



// WEBPACK FOOTER //
// ./src/containers/Admin/Statistics/Dashboard.jsx